module.exports = __webpack_public_path__ + "img/sneeze.737494be.jpg";